import { useSelector } from 'react-redux';

import { offerSelector } from '../../selectors';
import { IState } from '../../store';
import { IOfferData } from '../../types/offerData';

export function useOfferSelector(): IOfferData['offer'] {
  return useSelector<IState, IOfferData['offer']>(offerSelector);
}
